import { CountryModel } from 'src/app/domain/models/country.model';

export interface CountryState {
    contrys: CountryModel[];
}

export const initialContryState: CountryState = {
    contrys: [],
};
